var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from "react";
import styled from "styled-components";
import Tooltip from '@atlaskit/tooltip';
import QuestionCircleIcon from '@atlaskit/icon/glyph/question-circle';
import { useFlagOnError, useQuery, DynamicTable, FlexDiv, useAnalytics } from "@atlassiansox/microscopekit";
import aliasesQuery from "./aliases.query.graphql";
var ContainerDiv = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding-top: 1.5em;\n  width: 100%\n"], ["\n  padding-top: 1.5em;\n  width: 100%\n"])));
var MaybeBoldDiv = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (props) { return props.bold ? "font-weight: 800" : ""; });
export var AliasesTab = function (props) {
    var _a, _b;
    var track = useAnalytics();
    var serviceId = props.serviceId, environment = props.environment, shard = props.shard, type = props.type, deployId = props.deployId;
    var variables = {
        id: serviceId,
        input: {
            environments: [
                environment
            ]
        }
    };
    var _c = useQuery(aliasesQuery, {
        errorPolicy: "all",
        variables: variables
    }), loading = _c.loading, error = _c.error, data = _c.data;
    useFlagOnError({
        title: "Error",
        message: "There was an error retrieving service aliases.",
        type: "error",
    }, error);
    if (error) {
        track("MicrosDetailedDeploymentsPage.AliasesTab: FetchDataFailed", {
            category: "error"
        });
    }
    var head = {
        cells: [
            {
                key: "aliasURL",
                content: "Alias",
                width: 30
            },
            {
                key: "originalUrl",
                content: "Original URL",
                width: 30
            },
            {
                key: "type",
                content: "Type",
                width: 10
            },
            {
                key: "details",
                content: (React.createElement(FlexDiv, null,
                    "Details",
                    React.createElement(Tooltip, { content: "Extra details about how requests are routed for the given alias. The bolded text is the section that applies to the current deployment." },
                        React.createElement(QuestionCircleIcon, { size: "small", label: "help-icon" })))),
                width: 30
            },
        ],
    };
    if (loading || error) {
        return (React.createElement(ContainerDiv, null,
            React.createElement(DynamicTable, { head: head, rows: [], isLoading: loading })));
    }
    var env = environment.toLowerCase().replace("_", "-");
    var curShard = (((_b = (_a = data === null || data === void 0 ? void 0 : data.service) === null || _a === void 0 ? void 0 : _a.microsV2) === null || _b === void 0 ? void 0 : _b.shards) || []).find(function (s) { return s.label === shard; });
    var curEnv = ((curShard === null || curShard === void 0 ? void 0 : curShard.environments).items || []).find(function (e) { return e.name === env; });
    var deployment = curEnv.deployments[type];
    var aliases = deployment.aliases;
    if (type === "persistent" || type === "other") {
        aliases = deployment.find(function (deploy) { return deploy.id.includes(deployId); }).aliases;
    }
    var detailToHTML = function (detail) {
        if (!detail) {
            return "";
        }
        switch (detail.__typename) {
            case "MicrosFailoverRoutingPolicy":
                return (React.createElement(React.Fragment, null,
                    React.createElement(MaybeBoldDiv, { bold: detail.primary.id === env },
                        "primary: ",
                        detail.primary.id),
                    React.createElement(MaybeBoldDiv, { bold: detail.secondary.id === env },
                        "secondary: ",
                        detail.secondary.id)));
            case "MicrosWeightedRoutingPolicy":
                return (React.createElement(React.Fragment, null, detail.weights.map(function (weight) { return (React.createElement(MaybeBoldDiv, { bold: weight.env.id === env && (!weight.suffix || deployId === weight.suffix) },
                    "\u2022 ",
                    weight.env.id,
                    weight.suffix ? " (" + weight.suffix + ")" : "",
                    ": ",
                    weight.weight,
                    "%")); })));
        }
    };
    var rows = aliases.map(function (alias, index) { return ({
        cells: [
            { key: "rowAlias-" + index, content: alias.aliasUrl },
            { key: "rowOrig-" + index, content: alias.originalUrl },
            { key: "rowType-" + index, content: alias.type },
            { key: "rowDetails-" + index, content: detailToHTML(alias.detail) }
        ]
    }); });
    return (React.createElement(ContainerDiv, null,
        React.createElement(DynamicTable, { head: head, rows: rows, emptyView: React.createElement("div", null, "No aliases.") })));
};
var templateObject_1, templateObject_2;
